<template>
  <NavBar />
  <div class="container-fluid page-body-wrapper">
    <MenuBar />
    <div class="main-panel">
      <div class="content-wrapper">
        <div class="page-header">
          <h3 class="page-title">
            <span class="page-title-icon bg-gradient-primary text-white me-2">
              <i class="mdi mdi-format-list-bulleted"></i>
            </span>
            All Products
          </h3>
          <a
            class="btn btn-block btn-lg btn-gradient-primary mt-4"
            @click="btnShowCertificate"
            >Certificate Types</a
          >
        </div>
        <ManageCertificateTypes
          v-if="blnShowManagePRSec"
          v-on:toBeClose="getCloseAction"
        >
        </ManageCertificateTypes>

        <div class="row">
          <div class="col-12 grid-margin">
            <div class="card">
              <div class="card-body">
                <ProductsList></ProductsList>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MenuBar from "@/components/shared/common/menu-bar.vue";
import NavBar from "@/components/shared/common/nav-bar.vue";
import ManageCertificateTypes from "@/components/shared/products-certificates/manage-certificate-types.vue";
import ProductsList from "@/components/shared/products-certificates/products-list.vue";

const blnShowManagePRSec = false;
const lstProducts = [];
const objSelectePrd = {};

export default {
  name: "ReleasedProduct",
  components: {
    NavBar,
    MenuBar,
    ProductsList,
    ManageCertificateTypes,
  },
  data() {
    return {
      blnShowManagePRSec,
      lstProducts,
      objSelectePrd,
    };
  },
  methods: {
    btnShowCertificate() {
      this.blnShowManagePRSec = true;
    },
    getPostedData(obj) {
      
      if (
        this.lstProducts != undefined &&
        this.lstProducts != null &&
        this.lstProducts.length > 0
      ) {
        const index = this.lstProducts.findIndex(
          (item) => item.pcd_name == obj.pcd_name
        );
        
        if (index > -1) this.lstProducts[index] = obj;
        else this.lstProducts.push(obj);
      } else this.lstProducts.push(obj);
      this.blnShowManagePRSec = false;
    },
    getEventStatus(is_canceled) {
      if (is_canceled == true) {
        this.blnShowManagePRSec = false;
      }
    },
    getSelectedData(objselectedItem) {
      if (objselectedItem != null) {
        
        this.objSelectePrd = objselectedItem;
        this.blnShowManagePRSec = true;
      }
    },
    getCloseAction(toBeClose) {
      this.blnShowManagePRSec = toBeClose;
    },
  },
};
</script>

<style>
.p-dialog .p-dialog-header {
  padding-bottom: 0px;
}
</style>
